import {Component, OnDestroy, OnInit} from '@angular/core';
import { BaseComponent, WmsSpinnerComponent } from "@wms/components";
import { WmsTypeaheadComponent } from '../../../../components/wms-typeahead/wms-typeahead.component';
import { IssuesService } from "@wms/app/bottom-left-menu/components/issues/issues.service";
import {camelCase, filter, forEach, lowerCase, orderBy, upperFirst} from "lodash-es";
import { ApisService, NotificationService, ServiceFactoryService } from "@wms/services";
import { CommonModule, NgForOf } from "@angular/common";
import { VersionManagerPipe, DOC_LINKS} from '@wms/core'
import {WmsComboBoxComponent} from "@wms/app/components/wms-combo-box/wms-combo-box.component";
import {MixpanelService} from "@wms/app/services/mixpanel/mixpanel.service";
import {getClonedObject, runtimeEventManager} from "@wm/core";
import { Router } from '@angular/router';
@Component({
    selector: 'wms-api-issues',
    templateUrl: './api-issues.component.html',
    styleUrls: ['./api-issues.component.less'],
    standalone: true,
  imports: [
    WmsTypeaheadComponent,
    NgForOf,
    CommonModule,
    WmsSpinnerComponent,
    VersionManagerPipe,
    WmsComboBoxComponent
  ]
})
export class ApiIssuesComponent extends BaseComponent implements OnDestroy, OnInit {
  selectedAPI: any;
  apis: any[];
  apisDisplayObj: any;
  noAPISelected: boolean;
  selectedIssueLocation: any;
  issueLocations: any[];
  issueLocationsDisplayObj: any;
  noIssueLocationSelected: boolean;
  fetchingData: boolean;
  issues: any[];
  selectedIssue: any;
  hasNoIssues: any;
  refreshAPIIssuesSubscription: any;
  fetchAPIIssuesSubscription: any;
  prefix: any;
  suffix: any;
  isError: boolean = false;
  DOC_LINKS: {[key: string]: string};
  reImportApilink: string;
  isApiCount: any;
  constructor(
              public issuesService: IssuesService,
              private apiService: ApisService,
              private mixpanelService: MixpanelService,
              private notificationService: NotificationService,
              private router: Router,
              public serviceFactory: ServiceFactoryService
    ) {
    super();
    this.fetchIssues();
    this.refreshAPIIssuesSubscription = this.eventManager.refreshAPIIssuesObservable().subscribe(() => {
      this.mixpanelService.track('reimport_issue_refreshed');
      this.fetchIssues(this.selectedAPI, this.selectedIssueLocation)
    });
    this.fetchAPIIssuesSubscription = this.eventManager.fetchAPIIssuesObservable().subscribe((result:any) => this.fetchIssues(result.reimportedServiceId));
    this.issuesService.isAPIIssuesTabOpened = true;
    this.isApiCount = this.serviceFactory.services.some((service: { type: string; }) => service.type === "OpenAPIService");
  }

  ngOnInit(): void {
    this.reImportApilink = DOC_LINKS['RE_IMPORT_API_LINK'];
  }

  isItemExists(array: any[], item: any, key: string): boolean {
    let filteredEntity =  filter(array, (obj: any) => { return obj[key] === item[key]; });
    return filteredEntity.length === 0 ? false : true
  }

  fetchIssues(selectedAPI ?: any, selectedIssueLocation ?: any) {
    this.fetchingData   = true;
    this.hasNoIssues    = false;
    this.selectedIssue  = undefined;
    let index = 0, issuesCount = 0;
    this.issuesService.getServicesList().then((response: any) => {
      this.apis = orderBy(response.serviceIdVsIssues, 'issueCount', 'desc');
      forEach(this.apis, (api: any) => {
        api.displayName = api.serviceId + ' (' + api.issueCount + ')';
        issuesCount += api.issueCount;
        if(selectedAPI && api.serviceId === selectedAPI.serviceId) {
          selectedAPI.displayName = api.displayName;
          selectedAPI.issueCount  = api.issueCount;
        }
      });
      this.apisDisplayObj = [{
        headerTitle: this.locale.LABEL_API,
        subHeaderTitle: this.locale.LABEL_ISSUES.toUpperCase(),
        data: getClonedObject(this.apis)
      }];
      if(!selectedAPI && !selectedIssueLocation)
        this.mixpanelService.track('reimport_issue_tray_open', {
          'number_of_issues': issuesCount
        });
      // filter the service with max issues
      if(this.apiService.reimportedServiceId) {
        index = this.apis.findIndex(item => item.serviceId === this.apiService.reimportedServiceId);
      }
      this.hasNoIssues = this.apis.length === 0 ? true : false;
      if(this.hasNoIssues) {
        this.fetchingData = false;
      } else {
        this.selectedAPI = selectedAPI && this.isItemExists(this.apis, selectedAPI, 'serviceId') ? selectedAPI || this.apis[index] : this.apis[index];
        this.noAPISelected = false;
        this.updateIssueData(selectedIssueLocation);
      }
    }).catch((error: any) => {
      this.isError = true;
      this.handleFetchError(error);
    });
  }
  updateSelectedAPI(evt: any) {
    this.selectedAPI = evt;
    this.selectedIssue = undefined;
    this.noAPISelected = false;
    this.updateIssueData();
  }

  onAPIClear() {
    this.noAPISelected  = true;
    this.selectedIssue  = undefined;
    this.issueLocations = this.issueLocationsDisplayObj = [];
    this.selectedIssueLocation.displayName = undefined;
  }

  updateSelectedIssueLocation(event: any) {
    this.selectedIssueLocation = event;
    this.selectedIssue = undefined;
    this.noIssueLocationSelected = false;
    this.updateIssueLocation();
  }

  onIssueLocationClear() {
    this.noIssueLocationSelected = true;
    this.selectedIssue = undefined;
  }

  updateIssueData(selectedIssueLocation ?: any) {
    this.fetchingData = true;
    this.issuesService.getIssueLocationsByService(this.selectedAPI.serviceId).then((response: any) => {
      this.issueLocations = response.appInspectionReport ? orderBy([...[response.appInspectionReport], ...response.pageInspectionIssuesCounts], 'totalIssues', 'desc') : orderBy(response.pageInspectionIssuesCounts, 'totalIssues', 'desc');
      this.issueLocationsDisplayObj = [];
      if(response.appInspectionReport) {
        response.appInspectionReport.appVar   = response.appInspectionReport.pageName;
        response.appInspectionReport.pageName = response.appInspectionReport.displayName = this.locale.LABEL_PROJECTS_LIST_APPLICATION;
        this.issueLocationsDisplayObj.push({
          headerTitle: this.locale.LABEL_PROJECTS_LIST_APPLICATION.toUpperCase(),
          subHeaderTitle: this.locale.LABEL_ISSUES.toUpperCase(),
          data: [getClonedObject(response.appInspectionReport)]
        });
      }
      forEach(response.pageInspectionIssuesCounts, (issueLocation: any) => {
        issueLocation.displayName = issueLocation.pageName + ' (' + upperFirst(lowerCase(issueLocation.pageType)) + ')';
      });
      this.issueLocationsDisplayObj.push({
        headerTitle: this.locale.LABEL_PROPERTY_PAGE.toUpperCase(),
        subHeaderTitle: this.locale.LABEL_ISSUES.toUpperCase(),
        data: getClonedObject(orderBy(response.pageInspectionIssuesCounts, 'totalIssues', 'desc'))
      });
      this.selectedIssueLocation = selectedIssueLocation && this.isItemExists(this.issueLocations, selectedIssueLocation, 'pageName') ? selectedIssueLocation || this.issueLocations[0] : this.issueLocations[0];
      this.noIssueLocationSelected = false;
      return this.updateIssueLocation()
    }).catch((error: any) => {
      this.isError = true;
      this.handleFetchError(error);
    });
  }

  updateIssueLocation() {
    this.fetchingData = true;
    let pageName = this.selectedIssueLocation.pageName === 'Application' ? this.selectedIssueLocation.appVar : this.selectedIssueLocation.pageName;
    this.issuesService.getIssuesByIssueLocation(this.selectedAPI.serviceId, pageName).then((issuesList: any) => {
      this.issues = issuesList.issuesInfo;
      if(this.issues.length)
        this.selectedIssue = this.issues[0].issues[0];
      this.selectedIssueLocation.totalIssues = issuesList.totalIssueCount;
      this.fetchingData = false;
    }).catch((error: any) => {
      this.isError = true;
      this.handleFetchError(error);
    });
  }

  startsWithNote(value:any):boolean {
    return value.includes('NOTE') ? true : false;
  }

  isGoToPage(value: any): boolean {
    if(value.includes(this.locale.LABEL_DATA_TAB) || value.includes(this.locale.LABEL_GOTO_WIDGET)) {
      return false;
       }
    else if (value.includes('Go to')) {
      this.extractPrefixAndSuffix(value)
      return true;
    }
    return false;
  }

  extractPrefixAndSuffix(value:any){
    const index = value.indexOf(" '");
    this.prefix = value.substring(0, index);
    this.suffix = value.substring(value.indexOf("' ")).replace("'", "");
  }


  goToPage(pageName: string) {
    this.router.navigate(['page/' + pageName]);
    setTimeout(() => {
      runtimeEventManager.emit('loadPage', { pageName: pageName });
    });
  }

  handleFetchError(error: any) {
    this.fetchingData = false;
    this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, error);
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.issuesService.isAPIIssuesTabOpened = false;
    if(this.refreshAPIIssuesSubscription)
      this.refreshAPIIssuesSubscription.unsubscribe();
    if(this.fetchAPIIssuesSubscription)
      this.fetchAPIIssuesSubscription.unsubscribe();
  }
}
